module.exports = __webpack_public_path__ + "static/transform-section-bg-b1ff5a16354d601c2f6df099d332ab02.png";